import { gql } from '@apollo/client';
export const getCaseCallValidationQuery = gql `
  query case($id: String!) {
    case(id: $id) {
      id
      calls {
        id
        callServiceCallId
      }
    }
  }
`;
